import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useLayoutEffect, useRef, useState } from 'react';
import { useIsDesktopDimension } from '@carnica/utils/hooks';
import { useScrollContext } from "../../../../../shared/model";
export var useContextPosition = function useContextPosition(contexted, context, side) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    transform = _useState2[0],
    setTransform = _useState2[1];
  var _useState3 = useState({
      top: 0,
      left: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    menuOffset = _useState4[0],
    setMenuOffset = _useState4[1];
  var isDesktop = useIsDesktopDimension();
  var HEADER_HEIGHT = isDesktop ? 92 : 76;
  var messageRef = useRef(null);
  var menuRef = useRef(null);
  var wrapperRef = useRef(null);
  var _useScrollContext = useScrollContext(),
    containerRef = _useScrollContext.containerRef,
    scrollRef = _useScrollContext.scrollRef,
    containerHeight = _useScrollContext.containerHeight,
    scrollHeight = _useScrollContext.scrollHeight;
  useLayoutEffect(function () {
    var _menuRef$current, _wrapperRef$current;
    if (!contexted || !scrollRef.current || !containerRef.current || !messageRef.current) {
      setTransform(0);
      return;
    }
    var screenTop = messageRef.current.offsetTop - scrollRef.current.scrollTop;
    var blockSize = messageRef.current.offsetHeight + (((_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 ? void 0 : _menuRef$current.offsetHeight) || 0) + ((context === null || context === void 0 ? void 0 : context.reason) === 'reply' ? 0 : 8) + 16;
    setTransform(scrollRef.current.offsetHeight - blockSize - screenTop - HEADER_HEIGHT);
    var left = ((_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.offsetLeft) || 0;
    setMenuOffset({
      top: messageRef.current.offsetHeight + 8,
      left: side === 'main' ? Math.min(messageRef.current.offsetWidth - left, messageRef.current.offsetWidth - 200) : left
    });
  }, [messageRef, containerHeight, menuRef, scrollRef, contexted, wrapperRef, context === null || context === void 0 ? void 0 : context.reason, scrollHeight]);
  return {
    menuOffset: menuOffset,
    messageRef: messageRef,
    transform: transform,
    menuRef: menuRef,
    wrapperRef: wrapperRef
  };
};